var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',_vm._l((_vm.sriOptions),function(opt,index){return _c('b-button',{key:index,attrs:{"size":"sm","variant":_vm.checkboxSelected.includes(opt.value) ? 'primary' : 'outline-primary'},on:{"click":function($event){return _vm.pressed(opt.value)}}},[_vm._v(_vm._s(opt.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }